module.exports = {
  'en': {
    'HRMS6KEC1': {
      '10': 'Department',
      '20': 'Or Emp. Code',
      '30': 'Date Start',
      '40': 'To',
      '50': 'Doc. No.',
      '60': 'Period Date',
      '70': 'Before',
      '80': 'Holiday Work',
      '90': 'After working hours',
      '100': 'Department',
      '110': 'Last Approve By'
    },
    'HRES6KEC2': {
      '10': 'Request Date',
      '15': 'Req. No.',
      '20': 'O.T. Period',
      '30': 'Form Date',
      '40': 'To',
      '50': 'O.T. Time',
      '60': 'Before Work',
      '70': 'Holiday Work',
      '80': 'After Work',
      '90': 'Reason of request',
      '95': 'Remark',
      '99': 'Request for Details of O.T',
      '100': 'Approve By Next Step',
      '110': 'Actual Time in-out',
      '120': 'Update By'
    },
    'HRMS6KEC2': {
      '10': 'Doc. No.',
      '20': 'Over Time Detail',
      '30': 'Input Date',
      '40': 'For Department',
      '50': 'กลุ่มการทำงาน',
      '55': 'รหัสกะ',
      '60': 'Period Date',
      '70': 'From',
      '80': 'To',
      '90': 'ช่วงเวลาที่ขอ O.T.',
      '100': 'Befor Working',
      '110': 'ทำงานวันหยุด',
      '120': 'After Working',
      '130': 'สาเหตุการขอ',
      '140': 'รายละเอียดการขอ',
      '150': 'ผู้บันทึก'
    },
    'HRMS6KEC3': {
      '10': 'List of Employee',
      '20': 'O.T. Date',
      '30': 'ID',
      '40': 'Name',
      '50': 'O.T. Type',
      '60': 'Shift',
      '70': 'O.T. Time',
      '80': 'Status'
    }
  },
  'th': {
    'HRMS6KEC1': {
      '10': 'หน่วยงาน',
      '20': 'หรือ รหัสพนักงาน',
      '30': 'วันที่ตั้งแต่',
      '40': 'ถึง',
      '50': 'เลขที่เอกสาร',
      '60': 'ช่วงวันที่ขอ O.T.',
      '70': 'ก่อนเวลาทำงาน',
      '80': 'ทำงานวันหยุด',
      '90': 'หลังเวลาทำงาน',
      '100': 'หน่วยงาน',
      '110': 'ผู้อนุมัติล่าสุ'
    },
    'HRES6KEC2': {
      '10': 'วันที่ขอ',
      '15': 'ลำดับที่',
      '20': 'ช่วงวันที่ขอ O.T.',
      '30': 'ตั้งแต่วันที่',
      '40': 'ถึง',
      '50': 'เวลาขอ O.T',
      '60': 'ก่อนเวลาทำงาน',
      '70': 'ทำงานวันหยุด',
      '80': 'หลังเวลาทำงาน',
      '90': 'สาเหตุการขอ',
      '95': 'รายละเอียด',
      '99': 'คำร้องเรื่อง การขอทำงานล่วงเวลา',
      '100': 'อนุมัติโดยข้ามขั้นตอน',
      '110': 'รายละเอียดเวลาปฏิบัติงาน',
      '120': 'ผู้บันทึก'
    },
    'HRMS6KEC2': {
      '10': 'เลขที่เอกสาร',
      '20': 'รายละเอียด O.T.',
      '30': 'วันที่บันทึก',
      '40': 'สำหรับหน่วยงาน',
      '50': 'กลุ่มการทำงาน',
      '55': 'รหัสกะ',
      '60': 'ช่วงวันที่ขอ O.T.',
      '70': 'ตั้งแต่',
      '80': 'ถึง',
      '90': 'ช่วงเวลาที่ขอ O.T.',
      '100': 'ก่อนเวลาทำงาน',
      '110': 'ทำงานวันหยุด',
      '120': 'หลังเวลาทำงาน',
      '130': 'สาเหตุการขอ',
      '140': 'รายละเอียดการขอ',
      '150': 'ผู้บันทึก'
    },
    'HRMS6KEC3': {
      '10': 'รายชื่อพนักงาน',
      '20': 'วันที่ขอ O.T',
      '30': 'รหัสพนักงาน',
      '40': 'ชื่อ - สกุล',
      '50': 'ประเภท O.T.',
      '60': 'รหัสกะ',
      '70': 'เวลาขอ O.T',
      '80': 'สถานะการอนุมัติ'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hrms6ke.js